<template>
  <div :class="{ 'ring-offset-2 ring-primary-200 ring-4 rounded-md dark:ring-primary-800 dark:ring-offset-gray-900' : isActive }">
    <customer-select
      v-model="_customer"
      preview
      create
      shadow=""
      :ui="{
        content: 'max-h-[min(30rem,var(--reka-combobox-content-available-height,30rem))]',
      }"
    />
  </div>
</template>

<script setup lang="ts">
import CustomerSelect from '@/components/customer/elements/Select.vue'

interface Props {
  customer?: object | null
  isActive: boolean
}

interface Emits {
  (e: 'update:customer', value: any): void
}

const props = withDefaults(defineProps<Props>(), {
  customer: null,
})

const emit = defineEmits<Emits>()

const _customer = computed({
  get () {
    return props.customer
  },
  set (value) {
    emit('update:customer', value)
  },
})
</script>
